module.exports = __webpack_public_path__ + "static/media/API.489b0c69.svg";